<template>

    <div class="dmb-widget-styled-text" :style="resolvedTextStyle">
        <slot></slot>
    </div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'
import { resolveTextStyle } from "../util/style";

export default Options({
    name: 'dmb-widget-styled-text',
    props: {
        style: Object
    }
})(
    class WidgetStyledText extends Vue
    {
        get resolvedTextStyle() {
            return resolveTextStyle(this.style, this.showStyle);
        }

        get showStyle(){

            return this.$store.state.style.showStyle;
        }
    }
)

</script>
<style src="../../scss/component/WidgetStyledText.scss" lang="scss"></style>